<template>
  <el-col v-bind="$props">
    <slot />
  </el-col>
</template>

<script>
import { Col } from 'element-ui'
export default {
  name: 'col',
  props: {
    ...Col.props
  }
}
</script>



// WEBPACK FOOTER //
// col.vue?43a31ee1